/**
 * Holds a total that isn't known by the grid itself, e.g. an infinite-scroll
 * grid whose total comes from a separate count request. null means loading.
 */
export type GridTotalStore = {
  get: () => number | null;
  set: (value: number | null) => void;
  subscribe: (listener: () => void) => () => void;
};

export const createGridTotalStore = (): GridTotalStore => {
  let value: number | null = null;
  const listeners = new Set<() => void>();
  return {
    get: () => value,
    set: (next) => {
      value = next;
      listeners.forEach((l) => l());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
};

export const noStore: GridTotalStore = {
  get: () => null,
  set: () => undefined,
  subscribe: () => () => undefined,
};
